import { render, staticRenderFns } from "./ProductCreateUpdate.vue?vue&type=template&id=18bac3ca&scoped=true&"
import script from "./ProductCreateUpdate.vue?vue&type=script&lang=js&"
export * from "./ProductCreateUpdate.vue?vue&type=script&lang=js&"
import style0 from "./ProductCreateUpdate.vue?vue&type=style&index=0&id=18bac3ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18bac3ca",
  null
  
)

export default component.exports